import { toaster } from '@optiaxiom/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useOpalUser } from '@frontend/hooks';

import { DEFAULT_GET_STALE_TIME } from '../constants';
import { ConnectionServices } from '../services';
import { TurnstileInstanceUpdate } from '../types';

const CONNECTIONS_QUERY_KEY = 'connections';

export function useConnections() {
  const { opalUser } = useOpalUser();
  const queryClient = useQueryClient();

  const connectionQuery = useQuery({
    queryKey: [CONNECTIONS_QUERY_KEY],
    queryFn: async () => {
      if (!opalUser.instance.instance_id) {
        throw new Error('Instance ID is not set');
      }
      return await ConnectionServices.getConnections(opalUser.instance.instance_id);
    },
    staleTime: DEFAULT_GET_STALE_TIME * 5,
    retry: 1,
  });

  const connectionUpdater = useMutation({
    mutationFn: async (updates: TurnstileInstanceUpdate[]) => {
      if (!opalUser.instance.instance_id) {
        throw new Error('Instance ID is not set');
      }
      return await ConnectionServices.updateConnections(opalUser.instance.instance_id, updates);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['connections'] });
    },
    onError: error => {
      toaster.create('Something went wrong', {
        type: 'danger',
      });
      console.error(error);
    },
  });

  return {
    connectionGetter: {
      connections: connectionQuery.data || [],
      isPending: connectionQuery.isPending,
      isFetching: connectionQuery.isFetching,
      error: connectionQuery.error,
    },
    connectionUpdater: {
      updateConnections: connectionUpdater.mutate,
      isPending: connectionUpdater.isPending,
    },
  };
}
